module.exports = __webpack_public_path__ + "img/wallet-one-big.3a84cf17.svg";